import React, { useEffect, useState, useContext } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import {
  Chip,
  InputAdornment,
  Tooltip,
  Slide,
  Dialog,
  TextField,
  CircularProgress,
} from "@mui/material";
//import Select from "../../toolkit/Select";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { MenuItem } from "@mui/material";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "../Dashboard.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import VendorDetailsTab from "./VendorDetailsTab";
import CreateIcon from "@mui/icons-material/Create";
import TaskAltTwoToneIcon from "@mui/icons-material/TaskAltTwoTone";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import axios from "../../../utils/fvAxios";
import status from "../../../stories/StatusComponent/status.json";
import apiinfo from "../../../utils/base-uri.json";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import QuestionnaireSectionList from "../../../components/QuestionnaireTemplate/QuestionnaireSectionList";
import VendorStatusChange from "./VendorStatusChange";
import "./VendorDetails.css";
import Menu from "@mui/material/Menu";
import { useNavigate } from "react-router-dom";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import EmailtemplateList from "./Email/EmailTemplateList";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PqCommunicationContext } from "../../../store/pqCommunication-context";
import Backdrop from '@mui/material/Backdrop';
import FlagIcon from "@mui/icons-material/Flag";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import { getOrgId, getOrgType } from "../../../utils/Token";
import fileDownload from "js-file-download";
import ArchiveIcon from "@mui/icons-material/Archive";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { set } from "lodash";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import BgImage from "../../../Media/img/Expiration.png";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import { Divider, Box, Grid } from "@mui/material";
import Edit from "../../../icons/edit.svg";
import Eye from "../../../icons/Eye In.svg";
import Users from "../../../icons/Users.svg";
import Vector from "../../../icons/Vector.svg";
import Mail from "../../../icons/Mail.svg";
import FlagUp from "../../../icons/FlagUp.svg";
import FlagYellow from "../../../icons/FlagYellow.svg";
import Worker from "../../../icons/worker-safety-helmet.svg";
import Document from "../../../icons/invoice-accounting-documet-chart.svg";
import AStatus from "./AuditStatus.json";
import SelectYetQues from "../../../icons/VendorStatusIcons/Yet to select Questionnire.svg";
import WidgetDrawer from "../../../components/Widget/WidgetDrawer";
import { getviewallWidgit } from "../../../utils/Token";
import { styled } from '@mui/material/styles';
import { e } from "mathjs";
//import { QuestionnaireProvider } from "../../../store/questionnaire-context";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function VendorDetails(props) {
  const { globalPqDetails, setGlobalPqDetails } = useContext(
    PqCommunicationContext
  );
  const { t } = useTranslation();
  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };


  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");
  const Type = params.get("Type");
  const tab = params.get("tab");
  const isMultiClientId = params.get("ClientId");
  const SectionId = params.get("sectionid");
  const navigate = useNavigate();
  const Orgtype = getOrgType() == "Vendor" ? 1 : 0
  const [value, setValue] = React.useState(Orgtype);
  const handleChange = (event, newValue) => {
    // newValue === 0 &&
    //   tab == "Questionnaire" &&
    //   navigate("/vendordetails?pqid=" + PQID);
    setValue(newValue);
    // if (newValue !== 0) {
    //   setGlobalPqDetails({
    //     pqId: PQID,
    //     vendorName: PrequalificationDetails?.vendorName,
    //     clientName: PrequalificationDetails?.clientName,
    //   });
    // } else {
    //   setGlobalPqDetails({ pqId: 0, vendorName: "", clientName: "" });
    // }
  };
  // useEffect(()=>{
  //   VendorPrequalificationDetails();
  // },[])

  const [PrequalificationDetails, setPrequalificationDetails] = useState({});
  useEffect(() => {
    // setGlobalPqDetails({
    //   pqId: PQID,
    //   vendorName: PrequalificationDetails?.vendorName,
    //   clientName: PrequalificationDetails?.clientName,
    // });

    // if (tab == "Questionnaire") {
    setGlobalPqDetails({
      pqId: PQID,
      vendorName: PrequalificationDetails?.vendorName,
      clientName: PrequalificationDetails?.clientName,
    });
    // } else {
    //   setGlobalPqDetails({
    //     pqId: 0,
    //     vendorName: null,
    //     clientName: null,
    //   });
    // }
    return () =>
      setGlobalPqDetails({
        pqId: 0,
        vendorName: null,
        clientName: null,
      });
  }, [PrequalificationDetails]);

  const [contacts, setContacts] = useState([]);
  const [PqVendorOrgDetails, setPqVendorOrgDetails] = useState({});
  const [address, setAddress] = useState({});
  const [contactInformation, setContactInformation] = useState({});
  const [pqHistory, setPqHistory] = useState([]);
  const [fromOptions, setFromOptions] = useState([]);
  const [inviteDetails, setInviteDetails] = useState("");
  const [inviteDetailsFrom, setInviteDetailsFrom] = useState("");
  const [inviteDetails1, setInviteDetails1] = useState("");
  const [renewal, setRenewal] = useState("");
  const [Refresh, setRefresh] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [ClientTemplate, setClientTemplate] = useState("");
  const [evalutedVendors, setEvalutedVendors] = useState([]);
  const [previousPqDetails, setPreviousPqDetails] = useState("");
  const [VendorName, setVendorName] = useState("");
  const [CommentsSecPermisstion, setCommentsSecPermisstion] = useState(false);
  const [CommentsEditPermission, setCommentsEditPermission] = useState(false);
  const [PQCommentsHasFlag, setPQCommentsHasFlag] = useState(false);
  const [Flag, setFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [viewComment, setViewComment] = useState(false);
  const [isPrequalificationPdfExist, setIsPrequalificationPdfExist] = useState(false);
  const [HideLocations, setHideLocations] = useState("");
  const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
  const [languageId, setLanguageId] = useState(0);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [AuditStatusesList, setAuditStatusesList] = useState([]);
  const [AuditStatusId, setAuditStatusId] = useState("");
  const [ReAuditStatusId, setReAuditStatusId] = useState("");
  const [isMultipleStatus, setIsMultipleStatus] = useState(false);
  const [Object, setObject] = useState({});

  const [RenewlDetails, setRenewlDetails] = useState({});
  const [NewPqid, setNewPqid] = useState("");

  const [Count, setCount] = useState("");

  const AduitStatusinfo = AStatus?.find((r) => r?.auditStatusId == AuditStatusId);

  function VendorPrequalificationDetails() {
    axios
      .get(apiinfo.vendor.GetPQVendorDetailsAsync + "pqId=" + PQID)
      .then((res) => {
        setContacts(res?.data?.data?.pqVendorContacts);
        setPqVendorOrgDetails(res?.data?.data?.pqVendorOrgDetails?.generalInformation);
        setAddress(res?.data?.data?.pqVendorOrgDetails?.address);
        setContactInformation(
          res?.data?.data?.pqVendorOrgDetails?.contactInformation
        );
      })
      .catch((err) => {
        if (err?.response?.data?.responseCode == 401) {
          navigate("/DashBoard");
        }
      });

    axios
      .get(apiinfo.vendor.GetPQAndHeaderDetails + "pqId=" + PQID)
      .then((resp) => {
        setRenewlDetails(resp?.data?.data);
        setObject(resp?.data?.data)
        setPrequalificationDetails(resp?.data?.data?.pqVendorHeaderDetails);
        setVendorName(resp?.data?.data?.pqVendorHeaderDetails);
        setInviteDetails(
          resp?.data?.data?.localVendorInviteDetails?.invitationSentByUserId
        );
        setInviteDetailsFrom(resp?.data?.data?.localVendorInviteDetails?.invitationFrom);
        setInviteDetails1(resp?.data?.data?.localVendorInviteDetails)
        axios
          .get(
            "Prequalification/GetInvitationFromOptions?clientId=" +
            resp?.data?.data?.pqVendorHeaderDetails?.clientId
          )
          .then((resp) => {
            setFromOptions(resp?.data?.data);
          });
        setIsPaymentCompleted(resp?.data?.data?.paymentReceived);
        setHideLocations(resp?.data?.data?.hideLocations);
        setPqHistory(resp?.data?.data?.pqHistory);
        setRenewal(resp?.data?.data?.isEligibleForRenewal);
        setPreviousPqDetails(resp?.data?.data?.previousPQStatusDetails);
        setCommentsSecPermisstion(resp?.data?.data?.hasCommentsSecPermisstion);
        setCommentsEditPermission(
          resp?.data?.data?.haspredefineCommentsEditPermission
        );
        setPQCommentsHasFlag(resp?.data?.data?.pqCommentsHasFlag);
        setLanguageId(resp?.data?.data?.languageId);
        setIsPrequalificationPdfExist(
          resp?.data?.data?.isPrequalificationPdfExist
        );
        setAuditStatusId(resp?.data?.data?.auditStatusId);
        setReAuditStatusId(resp?.data?.data?.auditStatusId);
        setIsMultipleStatus(resp?.data?.data?.isSiteHasMultiStatus)
        setIsEdit(resp?.data?.data?.viewMode);

        if (getOrgType() == "Vendor" && resp?.data?.data?.isLocked == true)
          navigate("/DashBoard");
      })
      .catch((err) => {
        if (err?.response?.data?.responseCode == 401) {
          toastNotify("No Permissions Granted", false);
          navigate("/DashBoard");
        }
      });

    if (tab == "Questionnaire" || SectionId) setValue(1);
    // setEdit(false)
  }
  useEffect(() => {
    if (
      getOrgType() != "SuperClient" &&
      (getOrgType() == "Admin" || getOrgType() == "Client")
    ) {
      if (CommentsSecPermisstion != null && CommentsSecPermisstion == true) {
        if (
          (PQCommentsHasFlag == null || PQCommentsHasFlag == true) &&
          CommentsEditPermission == true
        ) {
          setFlag(true);
          setEditFlag(false);
          setViewComment(false);
        } else if (
          (PQCommentsHasFlag == null || PQCommentsHasFlag == false) &&
          CommentsEditPermission == true
        ) {
          setEditFlag(true);
          setFlag(false);
          setViewComment(false);
        } else if (CommentsEditPermission == false) {
          setViewComment(true);
          setFlag(false);
          setEditFlag(false);
        }
      }
    }
  }, [CommentsSecPermisstion, PQCommentsHasFlag, CommentsEditPermission]);

  const GetInvitationFromOptions = () => {
    axios
      .get(
        "Prequalification/GetInvitationFromOptions?clientId=" +
        PrequalificationDetails?.clientId
      )
      .then((res) => {
        setFromOptions(res?.data?.data);
      });
  };
  async function Organization() {
    const res = await axios.get(
      "/Organization/GetOrganizationUsers?orgId=" +
      getOrgId()
    );
    setEvalutedVendors(res?.data?.data);

    // axios
    //   .get(
    //     "Prequalification/GetInvitationFromOptions?clientId=" +
    //     PrequalificationDetails?.clientId
    //   )
    //   .then((resp) => {
    //     setFromOptions(resp?.data?.data);
    //   });
  }
  async function GetAuditStatuses() {
    const res = await axios.get("Prequalification/GetAuditStatuses");
    setAuditStatusesList(res?.data?.data);
  }

  useEffect(() => {
    if (PqVendorOrgDetails?.vendorId && PrequalificationDetails?.clientId) {
      axios
        .get("Employee/GetVendorEmployeeQuizList?VendorId=" + PqVendorOrgDetails?.vendorId + "&clientId=" + PrequalificationDetails?.clientId)
        .then((res) => {
          if (res.data) {
            setCount(res?.data?.data?.employeescount)
          }
        }).catch((err) => {
          console.log(err);
        });
    }
  }, [Refresh, PqVendorOrgDetails, PrequalificationDetails]);


  useEffect(() => {
    VendorPrequalificationDetails();
    GetAuditStatuses();
    GetComments();
    IsClientTemplate();
    if (Type == 1) {
      setView(!view);
    }
    setUpdateStatus(false);
  }, [Refresh, PQID, updateStatus, tab]);

  // useEffect(() => {
  //   VendorPrequalificationDetails();
  //   IsClientTemplate();
  //   if (Type == 1) {
  //     setView(!view);
  //   }
  // }, [PQID]);

  useEffect(() => {
    if (
      PrequalificationDetails &&
      PrequalificationDetails?.clientId &&
      PrequalificationDetails?.clientName &&
      PrequalificationDetails?.prequalificationStatusId && isPaymentCompleted
    )
      GetInvitationFromOptions();
    Organization();
    setInvite((inviteDetailsFrom == 0 || (inviteDetailsFrom == null && inviteDetails == null)) ? "0" : (inviteDetailsFrom == 1 ? "1" : inviteDetails)); //TODO:- we shows the which one is invited (persion ) default
  }, [PrequalificationDetails, inviteDetailsFrom, Refresh]);

  const IsClientTemplate = () => {
    axios
      .get("Prequalification/IsMultiClientTemplate?pqId=" + PQID)
      .then((resp) => {
        setClientTemplate(resp?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [view, setView] = useState(true);
  const Viewed = () => {
    setView((view) => !view);
    AnchorClose();
  };

  const [pqHistoryValue, setPqHistoryValue] = useState(PQID);
  // const navigate = useNavigate();
  const ChangePqId = (e) => {
    setPqHistoryValue(e);
    navigate("/vendordetails?pqid=" + e);
    setRefresh(!Refresh);
    setIsDownloading(false);
    setIsGeneratingPdf(false);
  };

  const [invite, setInvite] = useState("");
  const InvitationChange = (e) => {
    setInvite(e + "");
    const obj = {
      pqId: PQID,
      invitationFrom: e,
    };
    axios
      .post("Prequalification/UpdateInvitationFromInfo", obj)
      .then((resp) => {
        if (resp?.data?.data == "Success") {
          toastNotify(resp?.data?.data, true);
          setRefresh(!Refresh);
          setToggle(!Toggle);
        } else {
          toastNotify(resp?.data?.data, false);
        }
      });
  };

  const [firstPqClient, setFirstPqClient] = useState("");
  const [PqClients, setPqClients] = useState([]);

  useEffect(() => {
    axios
      .get("Prequalification/GetPqTemplateClients?pqId=" + PQID)
      .then((resp) => {
        setPqClients(resp?.data?.data);
        setFirstPqClient(resp?.data?.data[0]?.key);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [Refresh]);


  // useEffect(() => {
  //   if (getOrgType() === "Client") {
  //     axios
  //       .get("Employee/GetVendorEmployeeQuizList?VendorId=" + PqVendorOrgDetails?.vendorId + "&clientId=" + PrequalificationDetails?.clientId)
  //       .then((res) => {
  //         if (res.data) {
  //           setCount(res?.data?.data?.employeescount)
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }, []);



  const Status = status?.find(
    (r) =>
      r?.key ==
      (isMultipleStatus ? "Multiple"
        : PrequalificationDetails?.prequalificationStatusName)
  );

  const ITEM_HEIGHT = 50;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };

  const ViewMode = () => {
    setIsEdit(!isEdit);
  };

  const [open1, setOpen1] = React.useState(false);
  const [commentOpen, setcommentOpen] = React.useState(false);
  const [AuditStatuses, setAuditStatuses] = React.useState(false);

  const SaveAuditStatuses = async () => {
    const res = await axios.post("Prequalification/UpdatePqAuditStatus?pqId=" + PQID + "&auditStatusId=" + AuditStatusId);
    if (res?.data?.responseCode == 100) {
      toastNotify(res?.data?.responseMessage, true);
      setAuditStatuses(false);
      setRefresh(!Refresh);
    } else {
      toastNotify(res?.data?.responseMessage, false);
    }
  }

  const handleClickOpen = (event) => {

    if (event.ctrlKey) {
      const url = "./EmailTemplateList?pqid=" + PQID

      // Open the URL in a new tab
      window.open(url, '_blank');
    }
    else {
      setOpen1(true);
    }
  };
  const handleClose1 = () => {
    setOpen1(false);
  };
  const CommentClose = () => {
    setcommentOpen(false);
    setComments("");
  };
  const CommentOpen = (org) => {
    if (org == "Client") {
      setcommentOpen(true);
      GetComments();
    } else {
      setcommentOpen(true);
      GetComments();
    }
  };

  const [Comments, setComments] = React.useState("");
  const [ShowComments, setShowComments] = React.useState(null);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isloading, setloading] = useState(false);

  const PrequalificationRenewal = () => {
    if (RenewlDetails?.canForceRenewTemplate == false || RenewlDetails?.canForceRenewTemplate == null) {
      setloading(true);
      axios
        .post("Prequalification/CreateRenewalQuestionnaire?clientId=" + PrequalificationDetails?.clientId + "&vendorId=" + PqVendorOrgDetails?.vendorId + "&isMultiClient=" + RenewlDetails?.isMultiClient + "&copyAns=" + RenewlDetails?.copyAnswers + "&copyDoc=" + RenewlDetails?.copyDocs
        )
        .then((res) => {
          if (res?.data?.responseCode == 100) {
            toastNotify(res?.data?.responseMessage, true);
            window.history.pushState({}, "", window.location.pathname + "?pqid=" + res?.data?.data?.prequalificationId + "&tab=Questionnaire");
            setRefresh(!Refresh);
            setPqHistoryValue(res?.data?.data?.prequalificationId);
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        }).finally(() => {
          setloading(false);
        });
    } else {
      //Force Template Mapping For All Clients
      axios
        .get("Prequalification/GetClientTemplatesForRenewal?clientId=" + PrequalificationDetails?.clientId + "&vendorId=" + PqVendorOrgDetails?.vendorId + "&isMultiClient=" + RenewlDetails?.isMultiClient)
        .then((resp) => {
          if (resp?.data?.responseCode == 100) {
            const TemplateList = JSON.stringify(resp?.data?.data?.templates);
            if (resp?.data?.data?.templates?.length > 0) {
              navigate("/TemplatesList?startprq=" + TemplateList + "&pqid=" + resp?.data?.data?.prequalificationId + "&VendorId=" + PqVendorOrgDetails?.vendorId + "&copyAns=" + RenewlDetails?.copyAnswers + "&copyDoc=" + RenewlDetails?.copyDocs + "&ClientId=" + PrequalificationDetails?.clientId + "&IsMultiClient=" + RenewlDetails?.isMultiClient + "&CurrentTempID=" + RenewlDetails?.currentTemplateId);
            } else {
              toastNotify("No Templates", false);
            }
          } else {
            toastNotify(resp?.data?.responseMessage, false);
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
    //
  }

  const SaveComments = () => {
    const isEmpty = (value) =>
      value === null || value === undefined || value === "";
    if (!isEmpty(Comments?.trim())) {
      axios
        .post(
          "Vendor/UpdatePQBannerComment?PqId=" +
          PQID +
          "&Comments=" +
          Comments +
          "&IsChecked=" +
          checked
        )
        .then((res) => {
          if (res?.data?.responseCode == 100) {
            toastNotify(res?.data?.responseMessage, true);
            setcommentOpen(false);
            setComments("");
            GetComments();
          } else {
            toastNotify(res?.data?.responseMessage, false);
            setcommentOpen(true);
          }
          setRefresh(!Refresh);
        });
    } else {
      toastNotify("Please enter a comment", false);
    }
  };
  const GetComments = () => {
    axios.get("Vendor/GetPQBannerComment?PqId=" + PQID).then((res) => {
      if (res?.data?.responseCode == 100) {
        setShowComments(res?.data?.data?.comments);
        setComments(res?.data?.data?.comments);
        setChecked(res?.data?.data?.isChecked ?? false);
        setChecked1(res?.data?.data?.isChecked ?? false);
        setPQCommentsHasFlag(res?.data?.data?.isChecked);
      }
    });
  };

  const downloadArchivePdf = () => {
    setIsDownloading(true);
    axios
      .get(
        apiinfo.baseUrl +
        "Prequalification/DownloadPrequalificationPdf?pqid=" +
        PQID,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        setIsDownloading(false);
        fileDownload(res?.data, PQID + ".pdf");
      });
  };
  const GeneratePqPdf = () => {
    setIsGeneratingPdf(true);
    axios
      .get(
        apiinfo.baseUrl +
        "Prequalification/GeneratePrequalificationPdf?pqid=" +
        PQID
      )
      .then((res) => {
        if (
          res?.data?.responseCode == 100 &&
          res?.data?.responseMessage === "Success"
        )
          setIsPrequalificationPdfExist(true);
        setIsGeneratingPdf(false);
      });
  };
  // console.log(RenewlDetails?.copyAnswers);
  const handleAddNewClick = () => {
    if (getOrgType() == "Client") {
      navigate(
        "/GetClientEmployees?Vendor=" + PqVendorOrgDetails?.vendorId + "&Client=" + PrequalificationDetails?.clientId + "&pqId=" + PQID + "&back=true")

    } else {
      navigate(
        "/EmployeesList?Vendor=" + PqVendorOrgDetails?.vendorId + "&Client=" + PrequalificationDetails?.clientId + "&pqId=" + PQID + "&Tag=1")
    };
  }

  const GoFinanAnalitics = () => {
    let url = "/ClientAndAdminViewFinancialAnalytics?pqid=" + PQID + "&clientid=" + PrequalificationDetails?.clientId + "&vendorId=" + PqVendorOrgDetails?.vendorId + "&vname=" + PrequalificationDetails?.vendorName + "&ID=1";
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  const [anchor, setAnchor] = React.useState(null);
  const AnchorClick = (event) => {
    setAnchor(event.currentTarget);
  };
  const AnchorClose = () => {
    setAnchor(null);
  };
  const open2 = Boolean(anchor);
  // ABDUL FEE CAP START
  const [ISreachedFeecap, setISReachedFeecap] = useState();
  const data = (val) => {

    setISReachedFeecap(val);
    setTimeout(() => {
      if (val) {
        window.location.reload();
      }
    }, 1000);
  }
  // ABDUL FEE CAP END

  const [widgedVisible, setWidgedVisiblity] = useState(false); //  // widgit opening


  useEffect(() => {
    setWidgedVisiblity(getviewallWidgit());
  }, [getviewallWidgit()])
  // console.log(getviewallWidgit());
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;

  const handleOpenInNewTab = (event) => {
    // Create the URL with React Router or similar library
    if (event.ctrlKey) {
      const url = "./EmailTemplateList?pqid=" + PQID

      // Open the URL in a new tab
      window.open(url, '_blank');
    }
  };
  const [Toggle, setToggle] = useState(true);
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isloading}

      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* // widgit opening start */}


      {/* <WidgetDrawer
          widgedVisible={widgedVisible}
          onChangeVisibility={(resp) => setWidgedVisiblity(resp)}
        /> */}



      {/* // widgit opening end */}
      <Dialog
        fullScreen
        open={open1}
        onClose={() => handleClose1(1)}
        TransitionComponent={Transition}
      >
        <EmailtemplateList
          firstPqClient={firstPqClient}
          PqClients={PqClients}
          handleClose1={handleClose1}
        />
      </Dialog>

      <Dialog fullScreen={fullScreen} open={commentOpen}>
        <DialogContent>
          <FormControl sx={{ m: 1, width: 300 }}>
            <span style={{ color: "#3E4A62", marginTop: 1 }}>
              {t("VendorDetails.label35")}{" "}
            </span>
            <TextareaAutosize
              minRows={5}
              value={Comments}
              onChange={(e) => setComments(e?.target?.value)}
              disabled={viewComment}
            />
          </FormControl>
          <FormGroup style={{ marginLeft: "20px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={(e) => setChecked(e?.target?.checked)}
                  size="medium"
                  disabled={viewComment}
                />
              }
              label="	Deactivate Flag"
            />
          </FormGroup>
          <DialogActions>
            <div className={`login-help__buttonContainer mt-4`}>
              <Button
                variant="contained"
                className="login-help-button-cancel mx-2"
                onClick={() => { setChecked(checked1); CommentClose(); }}
              >
                {t("Myinformation.cancle")}
              </Button>
              <Button
                variant="contained"
                className="login-button-request mx-2"
                onClick={SaveComments}
                disabled={viewComment}
              >
                {t("Myinformation.save")}
              </Button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog >

      <Dialog fullScreen={fullScreen} open={AuditStatuses}>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: 20,
          }}
        >
          <span style={{ fontSize: "larger" }} >Audit Status</span>
        </DialogTitle>

        <DialogContent>
          <FormControl sx={{ m: 1, width: 300 }}>
            <span style={{ color: "#3E4A62", marginTop: 1 }}>
              Status
            </span>
            <Select
              id="outlined-basic"
              required
              size="small"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              variant="outlined"
              value={AuditStatusId}
              onChange={(e) => setAuditStatusId(e.target.value)}
              style={{ width: "100%", marginTop: "5px" }}
              MenuProps={MenuProps}
            >
              {AuditStatusesList?.map((r, index) => (
                <MenuItem key={index} value={r?.auditStatusId}>
                  {r?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <DialogActions>
            <div className={`login-help__buttonContainer mt-4`}>
              <Button
                variant="contained"
                className="login-help-button-cancel mx-2"
                onClick={() => { setAuditStatusId(ReAuditStatusId); setAuditStatuses(false) }}
              >
                {t("Myinformation.cancle")}
              </Button>
              <Button
                variant="contained"
                className="login-button-request mx-2"
                onClick={SaveAuditStatuses}

              >
                {t("Myinformation.save")}
              </Button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog >
      <ToastContainer />

      {/* New Questionaire title */}


      <Box className="mt-3 mx-4" sx={{ flexGrow: 1 }}>
        <Grid container spacing={{ xs: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          <Grid item xs={12} sm={4} md={4}>

            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "20px", backgroundColor: "#fff", borderRadius: "10px" }}>

              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",

                  }}
                >
                  <Tooltip title={PrequalificationDetails?.vendorName} placement="top" arrow>
                    <Box
                      sx={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "250px",
                      }}
                    >
                      <span style={{
                        textDecoration: "none",
                        color: "#2A93DB",
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontWeight: "600",
                        cursor: "pointer"
                      }}>
                        {PrequalificationDetails?.vendorName}
                      </span>
                    </Box>
                  </Tooltip>
                  <a
                    id="basic-button"
                    aria-controls={open2 ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open2 ? "true" : undefined}
                    onClick={AnchorClick}
                    style={{ cursor: "pointer" }}
                    className="text-muted"
                    hidden={getOrgType() == "Vendor" || getOrgType() == "Client"}
                  >
                    <MoreVertIcon />
                  </a>
                </Box>
                <Menu
                  anchorEl={anchor}
                  id="basic-menu"
                  open={open2}
                  style={{ textAlign: "center" }}
                  onClose={AnchorClose}
                  hidden={getOrgType() == "Vendor"}
                >
                  <Box sx={{ width: "150px", marginTop: "5px", marginBottom: "6px" }}>

                    <a onClick={Viewed}
                      style={{ color: "#000", textDecoration: "none", cursor: "pointer", }}
                    >
                      {view ?
                        <>{t("Dashboard.changestatus")} </> : "Vendor Details"}
                    </a>
                  </Box>
                </Menu>
                <Box >
                  <Tooltip title={PrequalificationDetails?.clientName} placement="top" arrow>
                    <h5 className="mt-2" style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400 }}>

                      <div style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}>
                        <span sx={{ marginRight: "auto" }}> {t("Dashboard.client")}:&thinsp;</span>
                        <span style={{
                          fontSize: "15px", color: "#101828", marginBottom: 5, overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}> {PrequalificationDetails?.clientName}</span></div>
                    </h5>
                  </Tooltip>
                </Box>
                <Box >
                  <h5 className="mt-2" style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400 }}>
                    <span sx={{ marginRight: "auto" }}>{t("Dashboard.statusPeriod")}:&thinsp;</span>
                    <span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {GetfVDateFormate(
                      PrequalificationDetails?.prequalificationStart
                    )}&nbsp;
                      {t("Dashboard.to")}
                      &nbsp;
                      {GetfVDateFormate(
                        PrequalificationDetails?.prequalificationFinish
                      )}</span>
                  </h5>

                </Box>
                <Box >
                  {/* {JSON.stringify(Status?.color)} */}
                  <Stack direction="row" spacing={2} >
                    <Card className="mt-2" sx={{ width: renewal ? "70%" : "100%", height: 55 }}>

                      <li
                        className="vendorCard"
                        style={{
                          backgroundColor: PrequalificationDetails?.prequalificationStatusId == 10 ? "#E4E7EC" : Status?.color,
                          listStyle: "none",
                          // backgroundImage:
                          //   PrequalificationDetails?.prequalificationStatusId == 10
                          //     ? `url(${BgImage})`
                          //     : "",
                        }}
                      >
                        <CardContent className="text-center" sx={{ color: "#fff" }}>
                          <span style={{ color: PrequalificationDetails?.prequalificationStatusId == 10 || PrequalificationDetails?.prequalificationStatusId == 34 ? "#000" : "#fff", fontSize: renewal ? "12px" : "15px" }}>
                            {[1, 2, 6, 11].includes(PrequalificationDetails?.prequalificationStatusId)
                              ?
                              <img
                                src={SelectYetQues}
                                alt={PrequalificationDetails?.prequalificationStatusName}
                              />
                              :
                              <img
                                src={Status?.imageUri}
                                alt={
                                  PrequalificationDetails?.prequalificationStatusId == 10
                                    ? previousPqDetails?.pqStatusName +
                                    "-" +
                                    PrequalificationDetails?.prequalificationStatusName
                                    : PrequalificationDetails?.prequalificationStatusName
                                }
                              //style={{ fontSize: "10px", width: "15px" }}
                              />
                            }
                            &nbsp;&nbsp;
                            {isMultipleStatus ? <span style={{ color: "#fff" }}>Multiple</span> : PrequalificationDetails?.prequalificationStatusId == 10
                              ? previousPqDetails?.pqStatusName +
                              "-" +
                              PrequalificationDetails?.prequalificationStatusName
                              : PrequalificationDetails?.prequalificationStatusName}
                          </span>
                        </CardContent>
                      </li>
                    </Card>

                    <Button
                      variant="contained"
                      className="mt-2"
                      hidden={!renewal}
                      sx={{
                        width: "40%",
                        padding: "5px",
                        textTransform: "capitalize",
                      }}
                      onClick={PrequalificationRenewal}
                    >
                      Renew
                    </Button>

                  </Stack>
                </Box>

              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4} md={4} hidden={getOrgType() == "Vendor"}>
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "20px", backgroundColor: "#fff", borderRadius: "10px" }}>
              <Stack direction="row">
                <Grid item xs={12} sm={8} md={8}>
                  <h5
                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400 }}>
                    <span sx={{ marginRight: "auto" }}>Risk level:</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {PrequalificationDetails?.templateCode}</span>
                  </h5>

                  <h5 className="mt-3" style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400 }}>
                    <span sx={{ marginRight: "auto" }}>Safety grade:</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}></span>
                  </h5>

                  <h5 className="mt-3" style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400 }} >
                    <span sx={{ marginRight: "auto" }}>Audit: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }} hidden={getOrgType() == "Vendor"}> <img src={AduitStatusinfo?.imageUri} alt={AduitStatusinfo?.name} />{AduitStatusinfo?.name}</span>
                  </h5>

                  <Stack className="mt-3" direction="row" spacing={3}>
                    <div>
                      {isPrequalificationPdfExist && (
                        <Card className="d-flex align-items-center gap-2 justify-content-between">
                          {isDownloading ? (
                            <Box sx={{ display: "flex" }}>
                              <CircularProgress />
                            </Box>
                          ) : (
                            <Tooltip title="Download Prequalification Pdf">
                              <IconButton
                                onClick={downloadArchivePdf}
                              >
                                <DownloadOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Card>
                      )}
                      {!isPrequalificationPdfExist && (
                        <Box className="d-flex align-items-center gap-2 ">
                          {isGeneratingPdf ? (
                            <Box sx={{ display: "flex" }}>
                              <CircularProgress />
                            </Box>
                          ) : (
                            <Tooltip title="Generate Prequalification Pdf">
                              <IconButton
                                className="btn btn-default border rounded"
                                onClick={GeneratePqPdf}
                              >
                                <ArchiveIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      )}
                    </div>
                    <Card sx={{ color: "#F2F4F7", padding: "4px", width: "35px", cursor: "pointer" }}
                      onClick={GoFinanAnalitics}
                    >
                      <img src={Document} alt=" WorkerIcon" />
                    </Card>
                    {/* <Card sx={{ color: "#F2F4F7", padding: "4px", width: "auto", cursor: "pointer" }} onClick={handleAddNewClick}>
                      <img src={Worker} alt=" WorkerIcon" /> <Chip sx={{ backgroundColor: "#12B76A", color: "#FFFFFF", borderRadius: "3px", cursor: "pointer" }} label={Count} />
                    </Card> */}
                    <a
                      href={
                        getOrgType() === "Client"
                          ? `/GetClientEmployees?Vendor=${PqVendorOrgDetails?.vendorId}&Client=${PrequalificationDetails?.clientId}&isMultiClientId=${isMultiClientId}&pqId=${PQID}&back=true`
                          : `/EmployeesList?Vendor=${PqVendorOrgDetails?.vendorId}&Client=${PrequalificationDetails?.clientId}&isMultiClientId=${isMultiClientId}&pqId=${PQID}&Tag=1`
                      }
                      // target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <Card sx={{ color: "#F2F4F7", padding: "4px", width: "auto", cursor: "pointer" }}>
                        <img src={Worker} alt="WorkerIcon" />
                        <Chip sx={{ backgroundColor: "#12B76A", color: "#FFFFFF", borderRadius: "3px", cursor: "pointer" }} label={Count} />
                      </Card>
                    </a>
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <Tooltip title={ShowComments} placement="top" arrow>
                    <Box sx={{
                      backgroundColor: "#FFF9F0", padding: "4px", width: "auto", height: "100%", cursor: "pointer", display: ShowComments == null || checked == true
                        ? "none"
                        : "block"
                    }}>

                      <div className="text-center mt-3" style={{ margin: "auto" }}>
                        <img src={FlagYellow} alt="FlagUp" />
                        <br />
                        <span style={{ color: "#DC6803" }}>Hover for  message!</span>
                      </div>
                    </Box>
                  </Tooltip>

                </Grid>
              </Stack>
            </Box>
          </Grid>


          <Grid item xs={12} sm={4} md={4} hidden={getOrgType() == "Vendor"}>
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "19px", backgroundColor: "#fff", borderRadius: "10px", height: getOrgType() === "Client" ? "185px" : "auto" }}
            >
              <div className="row" >
                <div className="col-md-2 text-center" >
                  {Flag == true ? (
                    <Tooltip title={"Activate Flag "} placement="top" arrow>
                      <Card sx={{ color: "#667085", cursor: "pointer", padding: "6px" }} onClick={() => CommentOpen(getOrgType())}>
                        <EmojiFlagsIcon />
                      </Card>
                    </Tooltip>
                  ) : editFlag == true ? (
                    <Tooltip title={"Activate Flag "} placement="top" arrow>
                      <Card sx={{ color: "#667085", cursor: "pointer", padding: "6px" }} onClick={() => CommentOpen(getOrgType())}>
                        <img src={FlagUp} alt="FlagUp" />
                      </Card>
                    </Tooltip>
                  ) : viewComment ? (
                    <Tooltip title={"Activate Flag "} placement="top" arrow>
                      <Card sx={{ color: "#667085", cursor: "pointer", padding: "6px" }} onClick={() => CommentOpen(getOrgType())}>
                        <FlagCircleIcon />
                      </Card>
                    </Tooltip>
                  ) : ""}
                </div>

                <div className="col-md-2 text-center" style={{ display: getOrgType() === "Client" ? "none" : "" }}>
                  <Tooltip title={"Audit Statuses"} placement="top" arrow>
                    <Card sx={{ color: "#667085", cursor: "pointer", padding: "5px" }} onClick={() => setAuditStatuses(true)}>
                      <img src={Vector} alt="VectorIcon" />
                    </Card>
                  </Tooltip>
                </div>

                {/* <div className="col-md-2 text-center" style={{ display: getOrgType() === "Client" && Count == 0 ? "none" : "" }}>
                  <Tooltip title={"Employees "} placement="top" arrow>
                    <Card sx={{ color: "#667085", cursor: "pointer", padding: "5px" }} onClick={handleAddNewClick}>
                      <img src={Users} alt="UsersIcon" />
                    </Card>
                  </Tooltip>
                </div> */}

                <div className="col-md-2 text-center" hidden={getOrgType() === "Client"}>
                  <Tooltip title={"Email "} placement="top" arrow>
                    <Card sx={{ color: "#667085", cursor: "pointer", padding: "5px" }}
                      // Replace with the actual path to your email template list component
                      onClick={(event) => handleClickOpen(event)}
                      // onContextMenu={(event) => {
                      //   event.preventDefault();
                      //   handleOpenInNewTab(event);
                      // }}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '7px',
                        color: '#667085',
                        cursor: 'pointer',
                      }}>
                      <img src={Mail} alt="MailIcon" />
                    </Card>
                  </Tooltip>
                </div>

                <div className="col-md-2 text-center" hidden={getOrgType() === "Client"}>
                  <Tooltip title={"View Mode "} placement="top" arrow>
                    <Card sx={{
                      backgroundColor: isEdit == true ? "#ffcc00" : "",
                      color: isEdit == true ? "#fff" : "#667085",
                      cursor: "pointer", padding: "5px"
                    }}
                      onClick={ViewMode}
                    >
                      <img src={Eye} alt="EyeIcon" />
                    </Card>
                  </Tooltip>
                </div>

                <div className="col-md-2 text-center" hidden={getOrgType() === "Client"}>
                  <Tooltip title={" Edit Company "} placement="top" arrow>
                    {/* <Card sx={{ color: "#667085", cursor: "pointer", padding: "5px" }} onClick={() => {
                      if (PqVendorOrgDetails?.vendorId)
                        navigate("/EditVendor?vendorid=" + PqVendorOrgDetails?.vendorId);
                    }} >
                      <img src={Edit} alt="EditIcon" />
                    </Card> */}
                    <a
                      href={PqVendorOrgDetails?.vendorId ? `/EditVendor?vendorid=${PqVendorOrgDetails?.vendorId}` : "#"}
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <Card
                        sx={{ color: "#667085", cursor: "pointer", padding: "5px" }}
                        onClick={(e) => {
                          if (!PqVendorOrgDetails?.vendorId) e.preventDefault();
                        }}
                      >
                        <img src={Edit} alt="EditIcon" />
                      </Card>
                    </a>
                  </Tooltip>
                </div>
              </div>

              <br />

              <div
                style={{
                  minWidth: "clamp(250px, 25%, 450px)",
                }}
              >

                <div >
                  <Stack direction={"row"} spacing={2}>

                    <Select
                      required
                      size="small"
                      hidden={getOrgType() == "Client"}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        overflow: "hidden",
                        width: "150px",
                        display: Toggle == true ? "none" : ""
                      }}
                      variant="outlined"
                      value={invite}
                      onChange={(e) => InvitationChange(e?.target?.value)}
                      style={{ width: "85%" }}
                      MenuProps={MenuProps}
                    >
                      {fromOptions?.map((r) => (
                        <MenuItem key={r?.value} value={r?.value}>
                          {r?.key}
                        </MenuItem>
                      ))}
                    </Select>
                    <h5 style={{ fontSize: "15px", color: "#667085", marginBottom: "20px", fontWeight: 400 }} hidden={!Toggle || getOrgType() == "Client"}>
                      <span sx={{ marginRight: "auto" }}>Invited by:</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {inviteDetails1?.invitationSentByUser == null || inviteDetails1?.invitationSentByUser == "" ? inviteDetails1?.invitationSentBy : inviteDetails1?.invitationSentByUser}</span>
                    </h5>
                    <Tooltip title={"Invited by: User"} placement="top" arrow>
                      <div
                        style={{ color: "#667085", cursor: "pointer" }}
                        onClick={(e) => setToggle(!Toggle)}
                        hidden={getOrgType() == "Client"}
                      >
                        <img src={Edit} alt="EditIcon" onClick={(e) => setToggle(!Toggle)}
                          hidden={getOrgType() == "Client"}
                        />
                      </div>

                    </Tooltip>
                  </Stack>
                </div>

                <h5 style={{ fontSize: "15px", color: "#667085", marginBottom: "20px", fontWeight: 400 }} hidden={getOrgType() != "Client"}>
                  <span sx={{ marginRight: "auto" }}>Invited by:</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {inviteDetails1?.invitationSentByUser == null || inviteDetails1?.invitationSentByUser == "" ? inviteDetails1?.invitationSentBy : inviteDetails1?.invitationSentByUser}</span>
                </h5>

                <Select
                  id="outlined-basic"
                  required
                  size="small"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  variant="outlined"
                  value={pqHistoryValue}
                  onChange={(e) => ChangePqId(e?.target?.value)}
                  style={{ width: "100%", marginTop: "5px" }}
                  MenuProps={MenuProps}
                >
                  {pqHistory?.map((r, index) => (
                    <MenuItem key={index} value={r?.value}>
                      {r?.text}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box >
      {/* New Questionaire title */}



      <div style={{ display: !view ? "none" : "block" }}>
        <Tabs
          className=""
          value={value}
          onChange={handleChange}
          variant="scrollable"
        >
          <Tab
            label="Vendor Details"
            sx={{
              marginLeft: 3, fontSize: "16px",
              fontWeight: 600,
              textTransform: "uppercase"
            }}
            {...a11yProps(0)}
            hidden={getOrgType() == "Vendor"}

          />
          <Tab
            label="Questionnaire"
            {...a11yProps(1)}

            sx={{
              marginLeft: getOrgType() == "Vendor" ? 3 : 0, fontSize: "16px",
              fontWeight: 600,
              textTransform: "uppercase"
            }}
          />
        </Tabs>
        <TabPanel value={Number(value)} index={0} hidden={getOrgType() == "Vendor"}>
          {PqVendorOrgDetails !== null &&
            address !== null &&
            contactInformation !== null &&
            PrequalificationDetails !== null && (
              <VendorDetailsTab
                PQSTID={PrequalificationDetails?.prequalificationStatusId}
                contact={contacts}
                details={{
                  PqVendorOrgDetails,
                  address,
                  contactInformation,
                  PrequalificationDetails,
                }}
                HiddeneLocations={HideLocations}
                Refresh={Refresh}
                PQCLIENTID={PrequalificationDetails?.clientId}
                evalutedVendors={evalutedVendors}
                Reset={setRefresh}
                COMMENT={ShowComments}
                Check={checked}
              />
            )}
        </TabPanel>

        <TabPanel value={Number(value)} index={1}>
          {/* <QuestionnaireProvider> */}
          <QuestionnaireSectionList
            BalcllistClientId={isMultiClientId}
            PQSTID={PrequalificationDetails?.prequalificationStatusId}
            ViewMode={!isEdit}
            isPaymentCompleted={isPaymentCompleted}
            PQCLIENTID={PrequalificationDetails?.clientId}
            ClientTemplate={ClientTemplate}
            pqId={PQID}
            ClientName={PrequalificationDetails?.clientName}
            languageId={languageId}
            pqStartDate={PrequalificationDetails?.prequalificationStart}
            pqClientVendorRef={PqVendorOrgDetails?.clientVendorRefId}
            vendorname={VendorName}
            IsMultiple={RenewlDetails?.isMultiClient}
            dataload1={data} // ABDUL FEE CAP END
            Obj={Object}
          />
          {/* </QuestionnaireProvider> */}
        </TabPanel>
      </div>

      {
        !view && (
          <VendorStatusChange
            Viewed={Viewed}
            Refresh={Refresh}
            Pageload={setRefresh}
            updateStatus={setUpdateStatus}
          />
        )
      }
    </>
  );
}
